import axios from 'axios';
import uuid from 'uuid/v1';

export const getContent = (customerType, contentApiEndPoint, dapiApiKey, ajaxExecutor = axios) => {
  return ajaxExecutor({
    headers: {
      'x-api-key': dapiApiKey,
      'x-od-trace-id': uuid(),
    },
    url: contentApiEndPoint + '/content',
    params: {
      customerType,
    },
  }).then((response) => {
    return response.data;
  });
};
